import React from "react";

import { IconMainMenuHelp } from "~/components/icon";

import { MainMenuItemLayout } from "./MainMenuItemLayout";

export const MainMenuItemHelp: React.FC = () => (
	<MainMenuItemLayout
		className="no-underline"
		href="https://docs.stackstate.com/"
		icon={<IconMainMenuHelp height={18} width={18} />}
		label="Help"
	/>
);
